import type { CSSProperties } from 'react'
import { NavigationViewMenu } from '@/components/layout/FloatingNavModeMenu'
import { useClientPortalLayout } from '@/contexts/ClientPortalLayoutContext'
import { getPortalContrastForeground } from '@/lib/portal/contrast'
import { useClientPortalStore } from '@/store/client-portal.store'

export function ClientPortalNavModeMenu({ className }: { className?: string }) {
  const mode = useClientPortalStore(state => state.navigationMode)
  const setMode = useClientPortalStore(state => state.setNavigationMode)
  const { branding } = useClientPortalLayout()
  // The dropdown is portaled to body. Carry branding with it on web; the
  // desktop title bar inherits these variables from the layout's html mirror.
  const style: Record<string, string> = {}
  if (branding.sidebarColor) {
    const light = getPortalContrastForeground(branding.sidebarColor) === 'white'
    style['--portal-sidebar'] = branding.sidebarColor
    style['--portal-sidebar-fg-hsl'] = light ? '0 0% 100%' : '0 0% 0%'
    style['--portal-sidebar-muted-fg-hsl'] = light ? '0 0% 72%' : '0 0% 38%'
  }
  if (branding.accentColor) style['--portal-accent'] = branding.accentColor
  return (
    <NavigationViewMenu
      mode={mode}
      onModeChange={setMode}
      className={className}
      portal
      contentStyle={style as CSSProperties}
    />
  )
}
